import { useRef, useState } from "react";
import { Col, Row } from "reactstrap";
import { FiChevronUp, FiChevronDown } from "react-icons/fi";
import { FaRegTrashAlt, FaRegEdit } from "react-icons/fa";
import DesktopVersionView from "../../../../../components/WholesalerComponents/Settings/StoreSetting/DesktopVersionView/DesktopVersionView";
import WhiteButton from "../../../../../components/WholesalerComponents/Settings/WhiteButton/WhiteButton";
import BackButton from "../../../../../components/common/BackButton/BackButton";
import LightGrayBgWrapper from "../../../../../components/common/AdminCommonComponents/LightGrayBgWrapper/LightGrayBgWrapper";
import SecondaryButton from "../../../../../components/common/SecondaryButton/SecondaryButton";
import Checkbox from "../../../../../components/common/Checkbox/Checkbox";
import DatatableComponent from "../../../../../components/common/DatatableComponent/DatatableComponent";
import PrimaryButton from "../../../../../components/common/PrimaryButton/PrimaryButton";
import SelectProductsModal from "./SelectProductsModal/SelectProductsModal";
import SelectBannerModal from "./SelectBannerModal/SelectBannerModal";
import brandImage from "../../../../../assets/images/OfficialBrandStore/brandImage.png";

const CreateNewTheme = () => {
  const [newLogo, setNewLogo] = useState(brandImage);

  const [addProductType, setAddProductType] = useState(null);
  const [addTrendyProductsType, setAddTrendyProductsType] = useState(null);
  const [addCampaignType, setAddCampaignType] = useState(null);
  const [isSelectProductsModalOpen, setIsSelectProductsModalOpen] =
    useState(false);
  const [isSelectBannerModalOpen, setIsSelectBannerModalOpen] = useState(false);

  const handleCheckboxChange = (type) => {
    setAddProductType(type);
  };
  const handleAddCampaignCheckboxChange = (type) => {
    setAddCampaignType(type);
  };
  const handleTrendyProductCheckboxChange = (type) => {
    setAddTrendyProductsType(type);
  };

  const handleOpenModal = () => {
    if (addProductType === "manual" || addTrendyProductsType === "manual") {
      setIsSelectProductsModalOpen(true);
    } else if (addCampaignType === "manual") {
      setIsSelectBannerModalOpen(true);
    }
  };

  const fileInputRef = useRef(null);

  const handleUploadLogoClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setNewLogo(imageUrl);
    }
  };

  const [campaignData, setCampaignData] = useState([
    {
      id: 1,
      media: "https://placehold.co/600x400",
      campaignName: "Summer Sale",
    },
    {
      id: 2,
      media: "https://placehold.co/600x400",
      campaignName: "Winter Sale",
    },
    {
      id: 3,
      media: "https://placehold.co/600x400",
      campaignName: "Spring Sale",
    },
    {
      id: 4,
      media: "https://placehold.co/600x400",
      campaignName: "Autumn Sale",
    },
  ]);

  const moveRow = (index, direction) => {
    const newData = [...campaignData];
    const newIndex = index + direction;
    if (newIndex >= 0 && newIndex < newData.length) {
      [newData[index], newData[newIndex]] = [newData[newIndex], newData[index]];
      setCampaignData(newData);
    }
  };

  const columns = [
    {
      name: "Media",
      cell: (row) => <img src={row.media} alt="" width={25} height={32} />,
      grow: 0.5,
    },
    { name: "Campaign Name", selector: (row) => row.campaignName },
    {
      name: "Action",
      cell: (row, index) => (
        <div className="d-flex gap-2 align-items-center">
          <div className="d-flex flex-column">
            <button
              onClick={() => moveRow(index, -1)}
              style={{ all: "unset", cursor: "pointer" }}
            >
              <FiChevronUp />
            </button>
            <button
              onClick={() => moveRow(index, 1)}
              style={{ all: "unset", cursor: "pointer" }}
            >
              <FiChevronDown />
            </button>
          </div>
          <div>
            <FaRegTrashAlt />
          </div>
          <div>
            <FaRegEdit />
          </div>
        </div>
      ),
    },
  ];

  return (
    <LightGrayBgWrapper>
      <BackButton />
      <div style={{ padding: "0px 20px 20px" }}>
        <div className="text-center fw-semibold fs-5">Create New Theme</div>
        <div className="fw-medium mt-4">
          Following are the different sections of Home page. You can easily edit
          by tabbing the required section or directly by selection from Section.{" "}
        </div>

        <Row className="g-0 mt-4 flex-column-reverse flex-xxl-row row-gap-5">
          <Col xs="12" xxl="8" className="pe-xxl-3">
            <DesktopVersionView
              url="http://localhost:3000/brand-store"
              height="200vh"
            />
          </Col>
          <Col xs="12" xxl="4" className="ps-xxl-3">
            <div
              style={{ backgroundColor: "#FBBD34" }}
              className="p-2 text-white fw-semibold"
            >
              Header
            </div>
            <div className="p-2 bg-white">
              <div className="p-2 border">
                <div>Logo</div>
                <div className="d-flex justify-content-between">
                  <div>
                    <WhiteButton onClick={handleUploadLogoClick}>
                      Update Logo
                    </WhiteButton>

                    <input
                      type="file"
                      ref={fileInputRef}
                      className="d-none"
                      accept="image/*"
                      onChange={handleFileChange}
                    />
                  </div>
                  <img
                    src={newLogo}
                    alt=""
                    className="shadow rounded-circle"
                    width={78}
                    height={78}
                  />
                </div>
              </div>
              <div className="p-2 border mt-2">
                <div>Cover Photo</div>
                <div>
                  <WhiteButton>Update Cover Photo</WhiteButton>
                </div>
              </div>
              <div className="d-flex justify-content-end gap-2 mt-2">
                <WhiteButton>Cancel</WhiteButton>

                <SecondaryButton name="Save" />
              </div>
            </div>

            {/* section divider */}

            <div
              style={{ backgroundColor: "#FBBD34" }}
              className="p-2 text-white fw-semibold"
            >
              Promotions
            </div>
            <div className="p-2 bg-white">
              <div className="p-2 border">
                <div>Add Campaign</div>
                <div className="d-flex gap-3 align-items-center mt-2">
                  <label className="d-flex align-items-center gap-2">
                    Auto
                    <Checkbox
                      checked={addCampaignType === "auto"}
                      onChange={() => handleAddCampaignCheckboxChange("auto")}
                    />
                  </label>
                  <label className="d-flex align-items-center gap-2">
                    Manual
                    <Checkbox
                      checked={addCampaignType === "manual"}
                      onChange={() => handleAddCampaignCheckboxChange("manual")}
                    />
                  </label>
                </div>

                {/* Show button only if 'Auto' is selected */}
                {addCampaignType === "manual" && (
                  <WhiteButton onClick={handleOpenModal}>
                    Add Campaign
                  </WhiteButton>
                )}
              </div>
              <div className="p-2 border mt-2">
                <div>Added Campaign</div>
                <DatatableComponent
                  data={campaignData}
                  columns={columns}
                  type="gray"
                />
              </div>
              <div className="d-flex justify-content-end gap-2 mt-2">
                <WhiteButton>Cancel</WhiteButton>
                <SecondaryButton name="Save" />
              </div>
            </div>

            {/* section divider */}

            <div
              style={{ backgroundColor: "#FBBD34" }}
              className="p-2 text-white fw-semibold"
            >
              Hot Deals
            </div>
            <div className="p-2 bg-white">
              <div className="p-2 border">
                <div>Add Products</div>
                <div className="d-flex gap-3 align-items-center mt-2">
                  <label className="d-flex align-items-center gap-2">
                    Auto
                    <Checkbox
                      checked={addProductType === "auto"}
                      onChange={() => handleCheckboxChange("auto")}
                    />
                  </label>
                  <label className="d-flex align-items-center gap-2">
                    Manual
                    <Checkbox
                      checked={addProductType === "manual"}
                      onChange={() => handleCheckboxChange("manual")}
                    />
                  </label>
                </div>

                {/* Show button only if 'Auto' is selected */}
                {addProductType === "manual" && (
                  <WhiteButton onClick={handleOpenModal}>Add Product</WhiteButton>
                )}
              </div>
              <div className="d-flex justify-content-end gap-2 mt-2">
                <WhiteButton>Cancel</WhiteButton>

                <SecondaryButton name="Save" />
              </div>
            </div>

            {/* section divider */}

            <div
              style={{ backgroundColor: "#FBBD34" }}
              className="p-2 text-white fw-semibold"
            >
              Trendy Products
            </div>
            <div className="p-2 bg-white">
              <div className="p-2 border">
                <div>Add Products</div>
                <div className="d-flex gap-3 align-items-center mt-2">
                  <label className="d-flex align-items-center gap-2">
                    Auto
                    <Checkbox
                      checked={addTrendyProductsType === "auto"}
                      onChange={() => handleTrendyProductCheckboxChange("auto")}
                    />
                  </label>
                  <label className="d-flex align-items-center gap-2">
                    Manual
                    <Checkbox
                      checked={addTrendyProductsType === "manual"}
                      onChange={() => handleTrendyProductCheckboxChange("manual")}
                    />
                  </label>
                </div>

                {/* Show button only if 'Auto' is selected */}
                {addTrendyProductsType === "manual" && (
                  <WhiteButton onClick={handleOpenModal}>Add Product</WhiteButton>
                )}
              </div>
              <div className="d-flex justify-content-end gap-2 mt-2">
                <WhiteButton>Cancel</WhiteButton>
                <SecondaryButton name="Save" />
              </div>
            </div>

            <div className="d-flex justify-content-end gap-2 mt-3">
              <WhiteButton>Cancel</WhiteButton>
              <PrimaryButton name="Save Changes" />
            </div>
          </Col>
        </Row>
      </div>

      <SelectProductsModal
        isModalOpen={isSelectProductsModalOpen}
        setIsModalOpen={setIsSelectProductsModalOpen}
      />
      <SelectBannerModal
        isModalOpen={isSelectBannerModalOpen}
        setIsModalOpen={setIsSelectBannerModalOpen}
      />

    </LightGrayBgWrapper>
  );
};

export default CreateNewTheme;